import { ActionTypes } from '../actionTypes';
import { Destination } from '../../types';

export const fetchDestinationsRequest = () => ({
  type: ActionTypes.FETCH_DESTINATIONS_REQUEST,
});

export const fetchDestinationsResponse = (destinations: Destination[]) => ({
  type: ActionTypes.FETCH_DESTINATIONS_RESPONSE,
  payload: destinations,
});

export const fetchDestinationsError = () => ({
  type: ActionTypes.FETCH_DESTINATIONS_ERROR,
});
